const SET_CUSTOMER = (state, { customerId, customer }) => {
  state.customers = { ...state.customers, [customerId]: customer };
};

const SET_FORCE_INTERSECT = (state, forceIntersect) => {
  state.force_intersect = forceIntersect;
};

const SET_PAGE_CATEGORY_ID = (state, id) => {
  state.category_id = id;
};
const SET_CATEGORY = (state, category) => {
  state.category = category;
  state.category_id = category?.id;
};

const SET_PAGE_INSTANCE = (state, instance) => {
  if (!instance && !state.instance) return;
  state.instance = {
    ...state.instance,
    ...instance,
  };
};

const RESET_PAGE_INSTANCE = (state) => {
  state.instance = null;
};

const RESET_CATEGORY = (state) => {
  state.category = null;
  state.category_id = null;
};
const SET_EXTENSIONS = (state, extensions) => {
  state.extensions = extensions;
};
const SET_ACTIVE_EXTENSION = (state, activeExtension) => {
  state.activeExtension = activeExtension;
};
const EXTENSIONS_LOADED = (state) => {
  state.extensionsLoaded = true;
};
const SET_EXTENSIONS_CALLED = (state, called) => {
  state.extensionsCalled = called;
};
const SET_ME = (state, me) => {
  state.me = me;
};

const SET_ME_LOADING = (state, loading) => {
  state.meLoading = loading;
};
const SET_ME_CALLED = (state, called) => {
  state.meCalled = called;
};
export default {
  SET_ME_CALLED,
  SET_ME_LOADING,
  SET_CATEGORY,
  EXTENSIONS_LOADED,
  SET_CUSTOMER,
  SET_EXTENSIONS_CALLED,
  SET_ACTIVE_EXTENSION,
  SET_EXTENSIONS,
  RESET_PAGE_INSTANCE,
  RESET_CATEGORY,
  SET_ME,
  SET_PAGE_INSTANCE,
  SET_PAGE_CATEGORY_ID,
  SET_FORCE_INTERSECT,
};
